export const versionData = {
  version: '1.3.37',
};
